<template>
  <div>
    <Breadcrumb msg1="商品库存" msg2="库存盘点" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5"><el-input v-model="query.check_no" placeholder="盘点单号" clearable></el-input></el-col>
        <el-col :span="5">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option label="盘点中" value="盘点中"></el-option>
            <el-option label="已完成" value="已完成"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-date-picker v-model="query.check_date" type="date" value-format="yyyy-MM-dd" placeholder="盘点日期"></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新建盘点单</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="盘点单号" prop="checkNo" width="160"></el-table-column>
        <el-table-column label="盘点日期" prop="checkDate" width="120"></el-table-column>
        <el-table-column label="操作员ID" prop="operatorId" width="100"></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已完成' ? 'success' : 'warning'">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" v-if="scope.row.status === '盘点中'" @click="openItems(scope.row)">录入明细</el-button>
            <el-button size="mini" type="success" v-if="scope.row.status === '盘点中'" @click="finish(scope.row)">完成盘点</el-button>
            <el-button size="mini" type="info" v-else @click="openItems(scope.row)">查看明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog title="新建盘点单" :visible.sync="addShow" width="450px" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="100px">
        <el-form-item label="盘点日期"><el-date-picker v-model="addForm.check_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addShow = false">取消</el-button>
        <el-button type="primary" @click="saveAdd">创建</el-button>
      </span>
    </el-dialog>

    <el-dialog title="盘点明细" :visible.sync="itemsShow" width="760px">
      <el-table :data="items" border size="small">
        <el-table-column label="SKU" width="160"><template slot-scope="scope">{{ skuCodeOf(scope.row.skuId) }}</template></el-table-column>
        <el-table-column label="SKU ID" prop="skuId" width="90"></el-table-column>
        <el-table-column label="账面库存" prop="bookStock" width="100"></el-table-column>
        <el-table-column label="实盘数量" width="140">
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.realStock" size="mini" :disabled="!editable"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="差异" prop="diff" width="90"></el-table-column>
      </el-table>
      <div style="margin-top: 10px">
        <el-button size="mini" icon="el-icon-plus" @click="addItemRow">添加SKU</el-button>
      </div>
      <span slot="footer">
        <el-button @click="itemsShow = false">关闭</el-button>
        <el-button type="primary" v-if="editable" @click="saveItems">保存明细</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, check_no: '', status: '', check_date: '' },
      list: [],
      total: 0,
      addShow: false,
      addForm: { check_date: '', operator_id: null, remark: '' },
      itemsShow: false,
      items: [],
      itemsRow: null,
      editable: false,
      skus: []
    }
  },
  created () {
    this.getData()
    this.$axios.http.get('/skus', { params: { page: 1, limit: 500 } }).then(r => {
      if (r.data.status === 200) this.skus = r.data.data.records || []
    })
  },
  methods: {
    skuCodeOf (id) { const s = this.skus.find(x => x.id === id); return s ? s.skuCode : '' },
    getData () {
      this.$axios.get('/stockChecks', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    add () {
      this.addForm = { check_date: '', operator_id: null, remark: '' }
      this.addShow = true
    },
    saveAdd () {
      this.$axios.post('/stockChecks', () => { this.addShow = false; this.getData() }, this.addForm)
    },
    openItems (row) {
      this.itemsRow = row
      this.editable = row.status === '盘点中'
      this.$axios.http.get(`/stockChecks/${row.id}`).then(r => {
        if (r.data.status === 200) {
          this.items = r.data.data.items || []
          this.itemsShow = true
        }
      })
    },
    addItemRow () {
      this.items.push({ skuId: null, realStock: 0, bookStock: 0, diff: 0 })
    },
    saveItems () {
      const items = this.items.map(i => ({ skuId: i.skuId, realStock: i.realStock }))
      this.$axios.put(`/stockChecks/${this.itemsRow.id}/items`, () => {
        this.$message.success('明细已保存')
        this.openItems(this.itemsRow)
      }, { items: items })
    },
    finish (row) {
      this.$axios.put(`/stockChecks/${row.id}/finish`, () => this.getData())
    }
  }
}
</script>
